'use client'

import { formatPrice } from '@/lib/formatters/currency.formatter'
import { ProductPriceIncludedTaxLink } from '../product-price-included-tax/ProductPriceIncludedTaxLink.client'

export type ProductPriceIncludedTaxProps = {
  inclTaxPrice?: number
  hideCurrencySymbol?: boolean
}

export function ProductPriceIncludedTax({
  inclTaxPrice,
  hideCurrencySymbol = false,
}: ProductPriceIncludedTaxProps): React.ReactElement | null {
  if (!inclTaxPrice || inclTaxPrice <= 0) {
    return null
  }

  const formattedPrice = hideCurrencySymbol
    ? formatPrice(inclTaxPrice, false)
    : formatPrice(inclTaxPrice)

  return (
    <span className="text-sm font-medium text-brand-2-900">
      {formattedPrice} <ProductPriceIncludedTaxLink />
    </span>
  )
}
